import React from "react";
import PlaceholderBanner from "./PlaceHolderBanner";
import Slider from "react-slick";
import './PlaceHolderHome.css'; // Asegúrate de crear este archivo o integrar el CSS
import { sliderOptions } from '../../../../../core/data/config/slider';

const PlaceHolderHome = () => {
  const placeholderItems = Array.from({ length: 3 }); // Simula 3 slides
  const cardsPerSection = 3;
  const sections = Array.from({ length: Math.ceil(3) });

  return (
    <div className="home-page">
      <Slider {...sliderOptions} className="img-slider nav-center hero-section slick-slider slide-arrows-hero bg-section-secondary slide-arrow-primary">
          <PlaceholderBanner  />
      </Slider>
      <section className="section p-0 py-md-5 py-4 text-home">
        <div className="container col-11 py-md-5 py-4">
          <div className="row justify-content-center">
            <div className="col-lg-5 text-center">
              <div className="section-header text-center">
                <div className="section-header text-center">
                  <h2 className="mb-1">
                    <span className="text-linear-primary">
                      NUESTRAS CLASES
                    </span>
                  </h2>
                  <p className="sub-title">
                    Nuestras clases son de máximo 15 chicas para poder brindar una experiencia semi-personalizada.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {placeholderItems.map((_, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="placeholder-card shimmer">
                  <div className="placeholder-image shimmer" />
                  <div className="placeholder-content">
                    <div className="placeholder-line short shimmer" />
                    <div className="placeholder-line shimmer" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="service-section">
        <div className="container py-md-5 col-11 py-3">
          <div className="row py-md-4 mt-0 align-items-center">
            <div className="col-12 d-flex justify-content-center">
              <div className="placeholder-title title shimmer w-50" />
              <div className="placeholder-line text shimmer" />
            </div>
          </div>
        </div>
      </section>
      <section className="section" id="package-placeholder">
      <div className="container col-11">
        {sections.map((_, sectionIndex) => (
          <div key={sectionIndex} className="col-12 my-4 text-home">
            {/* Placeholder Header */}
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="section-heading sec-header text-home shimmer">
                  <div className="placeholder-title title shimmer w-50 mx-auto mb-2" />
                  <div className="placeholder-line text shimmer w-25 mx-auto" />
                </div>
              </div>
            </div>

            {/* Placeholder Cards */}
            <div className="row mt-4">
              {Array.from({ length: cardsPerSection }).map((_, index) => (
                <div className="col-lg-4 col-sm-12 mb-4" key={index}>
                  <div className="pricing-plans price-new shimmer">
                      <div className="placeholder-title shimmer w-75 mx-auto" />
                    <div className="pricing-planscontent mb-2">
                      {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="placeholder-line shimmer w-100 mb-3" />
                      ))}
                    </div>
                    <div className="pricing-btn d-flex justify-content-center">
                      <div className="placeholder-button shimmer w-50" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
    </div>
  );
};

export default PlaceHolderHome;